package kz.dentalcrm.app.data.network.response_model.services_category

import kotlinx.serialization.Serializable

@Serializable
data class ServiceCategory(
    val created_at: String? = null,
    val id: Int,
    val name: String? = null,
    val organization_id: Int? = null,
    val updated_at: String? = null
)